import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/features/login/Header';
import apiService from '../../services/api';
import { email as validateEmail } from '../../utils/validation';
import './RecuperacaoSenha.css';

export default function EsqueciSenha() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    const normalizedEmail = email.trim().toLowerCase();
    const validationError = validateEmail(normalizedEmail);
    if (!normalizedEmail || validationError) {
      setError(validationError || 'Informe seu e-mail.');
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');
    try {
      const response = await apiService.solicitarRecuperacaoSenha(normalizedEmail);
      setMessage(response.message);
    } catch (requestError) {
      setError(requestError.message || 'Não foi possível processar a solicitação. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="password-recovery-page">
      <Header />
      <section className="password-recovery-panel" aria-labelledby="recovery-title">
        <h1 id="recovery-title">Recuperar senha</h1>
        <p className="password-recovery-intro">Informe o e-mail cadastrado para receber um link temporário de redefinição.</p>
        {message && <div className="password-recovery-message" role="status">{message}</div>}
        {error && <div className="password-recovery-message error" role="alert">{error}</div>}
        <form onSubmit={handleSubmit} noValidate>
          <div className="password-recovery-field">
            <label htmlFor="recovery-email">E-mail</label>
            <input className="password-recovery-input" id="recovery-email" name="email" type="email" autoComplete="email" maxLength={254} value={email} onChange={(event) => setEmail(event.target.value)} disabled={loading} required />
          </div>
          <button className="password-recovery-submit" type="submit" disabled={loading}>
            {loading ? 'Enviando...' : message ? 'Enviar novo link' : 'Enviar link de recuperação'}
          </button>
        </form>
        <Link className="password-recovery-back" to="/">Voltar ao login</Link>
      </section>
    </main>
  );
}
